import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./Locales/en/translation.json";
import es from "./Locales/es/translation.json";

// Obtener el idioma guardado, si no hay ninguno, no establecer uno por defecto
const savedLang = localStorage.getItem("language");

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: savedLang || "es", // Usar el idioma guardado o "es" como último recurso
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;